// import A11yDialog from "a11y-dialog";
//
// $('.modal').each(function () {
//     // fixed position becomes relative to the container when container-type is set, so move our modals out to the body
//     $(this).detach().appendTo($("body"));
//     let container = $(this)[0];
//     let dialog = new A11yDialog(container);
//     dialog.on('hide', function (event) {
//         const container = event.target;
//         let $frame = $(container).find('iframe');
//         let src = $frame.attr('src');
//         $frame.removeAttr('loading'); // lazy loading will prevent the frame from loading again
//         $frame.attr('src', '');
//         $frame.attr('src', src);
//     });
// });
//
// $('.video-modal').each(function () {
//     $(this).find('p.visuallyHidden').text($(this).find('iframe').attr('title'));
// });
//
// $('[data-dismiss=modal]').on('click', function (e) {
//     e.preventDefault();
//     let modal = $(this).closest('.modal');
//     if (modal.length) {
//         modal.removeClass('active');
//         modal.trigger('hide');
//     }
// });

function stopIframe(iframe) {
    var newSrc = iframe.src;
    newSrc = newSrc.replace('&autoplay=1', '');
    iframe.src = '';
    setTimeout(function () {
        iframe.src = newSrc;
    }, 1000);
}

$('.video-modal').on('shown.bs.modal', function(e) {
    let iframe = $(this).find('iframe')[0],
        src = iframe.src;

    if (src.indexOf('&autoplay=1') === -1) {
        iframe.src = src + '&autoplay=1&mute=1';
    }
});

// $('figure.iframe-video').each(function() {
//     let iframe = $(this).find('iframe'),
//         ratio = iframe.attr('height') / iframe.attr('width');
//     $(this).css('padding-bottom', ratio * 100 + '%');
// });

$('.video-modal').on('hide.bs.modal', function(e) {
    let iframe = $(this).find('iframe')[0];

    stopIframe(iframe);
});


